import { render, staticRenderFns } from "./PanelBookingPolicy.vue?vue&type=template&id=6e0f76c2&scoped=true"
import script from "./PanelBookingPolicy.vue?vue&type=script&lang=js"
export * from "./PanelBookingPolicy.vue?vue&type=script&lang=js"
import style0 from "./PanelBookingPolicy.vue?vue&type=style&index=0&id=6e0f76c2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0f76c2",
  null
  
)

export default component.exports